import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MiscSnackBarService } from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import { AdminPanelService } from '../../../data/admin-panel.service';
import { EmailCondition } from '../../../data/email-condition';
import { TemporaryVariable } from '../../../data/temporary-variable';

@Component({
  selector: 'app-email-changer-dialog',
  templateUrl: './email-changer-dialog.component.html',
  styleUrls: ['./email-changer-dialog.component.scss']
})
export class EmailChangerDialogComponent implements OnInit {
  saveLoading = false;

  variablesLoading = false;

  tempCondition: EmailCondition

  tempVariables: TemporaryVariable[];

  @ViewChild('emailChangerArea', {static: true})
  addPunchItemTextArea: ElementRef;

  constructor(
    private el: ElementRef,
    protected dialogRef: MatDialogRef<EmailChangerDialogComponent>,
    protected adminPanelService: AdminPanelService,
    private miscSnackBarService: MiscSnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: {
      condition: EmailCondition
    }
  ) {
  }

  ngOnInit(): void {
    this.tempCondition = Object.assign({}, this.data.condition)

    this.variablesLoading = true;

    this.adminPanelService.getConditionTemplates(this.tempCondition.clazz).subscribe(vars => {
      this.tempVariables = vars;

      this.variablesLoading = false;
    }, error => {
      this.variablesLoading = false;
    })
  }

  saveEmail() {
    this.saveLoading = true;

    this.adminPanelService.saveClientsCondition(this.tempCondition).subscribe(newCond => {
      this.miscSnackBarService.openSuccessSnackBar('Success!')

      this.dialogRef.close(newCond);
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.saveLoading = false;
    })
  }

  variableClick(variable: string) {
    if(!this.saveLoading) {
      const textAreaElement = this.addPunchItemTextArea.nativeElement as HTMLTextAreaElement
      const cursorPosition = textAreaElement.selectionEnd;

      textAreaElement.value = this.addStr(textAreaElement.value, cursorPosition, variable + ' ');
      textAreaElement.setSelectionRange(cursorPosition + variable.length + 1, cursorPosition + variable.length + 1);
      textAreaElement.focus()
    }

  }

  addStr(str: string, index: number, stringToAdd: string) {
    return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }


}
